import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';

const RelatedProjectCard = ({ project }) => (
  <Link data-testid={`related-project-${project.slug}`} to={`/projeler/${project.slug}`} className="group relative rounded-2xl overflow-hidden bg-card border border-border hover:border-primary/50 transition-colors duration-500">
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={project.image} alt={project.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <div className="flex items-center gap-1.5 mb-2 text-[10.5px] tracking-[0.22em] text-accent uppercase font-medium"><MapPin size={11} />{project.location}</div>
        <h3 className="text-[17px] font-semibold text-white leading-snug">{project.title}</h3>
      </div>
    </div>
  </Link>
);

export const RelatedProjects = ({ projects }) => {
  if (!projects.length) return null;
  return (
    <section id="related" className="px-6 lg:px-10 py-16 lg:py-20 bg-card/40">
      <div className="max-w-[1300px] mx-auto">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="flex items-center gap-3 mb-4"><span className="h-px w-10 bg-primary" /><span className="text-[11px] tracking-[0.28em] text-accent font-medium">ORNEK UYGULAMALAR</span></div>
            <h2 className="text-[30px] sm:text-[36px] lg:text-[42px] font-semibold text-white leading-tight">Bu urunun kullanildigi projeler</h2>
          </div>
          <Link data-testid="product-all-projects-link" to="/projeler" className="inline-flex items-center gap-2 text-[13px] tracking-[0.18em] font-semibold text-accent hover:text-white transition-colors group">TUM PROJELER<ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" /></Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {projects.slice(0, 6).map((project) => <RelatedProjectCard key={project.slug} project={project} />)}
        </div>
      </div>
    </section>
  );
};